/**
 * @desc OMS修改出库计划单单价（特殊问题需要修数才调用，正常情况不要调用）
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.fulfilment.OutPlanUpdatePriceRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/updateOutPlanPrice`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
